<!-- Component that implements a list of documents -->
<template lang="html">
  <div>
    <v-data-table
    :headers="headers"
    :items="listaAtividades"
    :search="search"
    :no-data-text="'Este projeto não possui atividades.'"
    must-sort
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :items-per-page="itemsPerPage"
    :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >
      <template v-slot:item.descricao="props">
        <div v-if="projeto.funcao != null && projeto.funcao.item === 1">
          <router-link :to="{ name: 'EditarAtividade', params: { idProjeto: idProjeto, idAtividade: props.item.id }}">
            {{ props.item.descricao }}
          </router-link>
        </div>
        <div v-else>
          {{ props.item.descricao }}
        </div>
      </template>
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaAtividades.length }} atividades
      </template>
    </v-data-table>
    <br><br>
    <v-divider></v-divider>
    <v-card-actions v-if="projeto.funcao != null && projeto.funcao.item === 1">
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="toCriarAtividade" >Nova Atividade</v-btn>
      <v-btn color="primary" text @click="toAvancar" >Avançar</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'projeto'],
  data: () => ({
    listaAtividades: [],
    dates: dates,
    search: null,
    sortBy: 'funcao.descricao',
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Descrição', align: 'left', value: 'descricao' },
      { text: 'Detalhamento', align: 'left', value: 'detalhamento' },
      { text: 'Início', align: 'left', value: 'dtInicioPrevisto' },
      { text: 'Fim', align: 'left', value: 'dtFimPrevisto' }
    ]
  }),
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']),
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    toCriarAtividade: function () {
      this.$router.push({ name: 'NovaAtividade', params: {idProjeto: this.idProjeto} })
    },
    toAvancar: function () {
      this.$router.push({ name: 'EditarParcerias', params: {idProjeto: this.projeto.idProjeto} })
    }
  },
  mounted () {
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando atividades.' })
    projetos.getAtividadesDoProjeto(this.idProjeto)
    .then(response => {
      this.listaAtividades = response.data.slice()
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando atividades.' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'tooltip': ToolTip
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// projeto-editar-atividades.vue?8cd7928c